import action from "../helpers/rest-client";

export class ErrorNewsletter extends Error { }

class Newsletter {
  public async unsubscribe(payload: { email: string }) {
    console.log('🔍 [Frontend Newsletter] unsubscribe - Iniciando...');
    console.log('📧 [Frontend Newsletter] unsubscribe - Email:', payload.email);
    console.log('📡 [Frontend Newsletter] unsubscribe - Llamando a API...');

    return action
      .Post({
        url: `/api/email-manager/unsubscribe`,
        body: payload,
      })
      .then((response) => {
        console.log('✅ [Frontend Newsletter] unsubscribe - Respuesta exitosa:', response);
        return { response };
      })
      .catch((error) => {
        console.error('❌ [Frontend Newsletter] unsubscribe - Error:', error);
        console.error('❌ [Frontend Newsletter] unsubscribe - Error message:', error.message);
        return { error };
      });
  }
}

const newsletter = new Newsletter();
export default newsletter; 